export default __webpack_public_path__ + "static/media/dark-forest.d50938fc.jpg";